import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
// import goldlog from "@ali/goldlog";
import "./index.scss";
var Cpv = /*#__PURE__*/function (_Component) {
  function Cpv() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Cpv, _Component);
  var _proto = Cpv.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      pid = _this$props.pid,
      templateId = _this$props.templateId,
      session_id = _this$props.session_id,
      adgroup_id = _this$props.adgroup_id,
      blockId = _this$props.blockId,
      cpv = _this$props.cpv;
    var cpvData = (cpv === null || cpv === void 0 ? void 0 : cpv.slice(0, 3)) || [];
    var materialIds = cpvData.map(function (v) {
      return v.materialId;
    }).join(",");

    // cpvData.length >= 2 &&
    //   goldlog.record(
    //     "/btob.wxb.zhurong_exp",
    //     "EXP",
    //     `exp_type='cpv'&pid=${pid}&templateId=${templateId}&blockId=${blockId}&materialIds=${materialIds}&session_id=${session_id}&adgroup_id=${adgroup_id}`,
    //     "GET"
    //   );
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      cpv = _this$props2.cpv,
      pid = _this$props2.pid;
    var cpvData = cpv && cpv.slice(0, 3) || [];

    // pc主搜右侧 pid: 819036_1008
    if (cpvData.length <= 1 && pid === "819036_1008") {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "zr-cpv"
    }, cpvData.length >= 2 && cpvData.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "cpv-container",
        title: item.p + "\uFF1A" + item.v,
        key: index
      }, /*#__PURE__*/React.createElement("span", null, item.v), /*#__PURE__*/React.createElement("span", null, item.p));
    }));
  };
  return Cpv;
}(Component);
export default Cpv;